<template>
  <div class="normalpaper">
    <div class="header">
      <div class="contain_main">
        <div class="logo">
          <img src="@/assets/header/logo.png" alt>
        </div>
        <div>
          <!-- <div class="button" @click="scan">预览</div> -->
          <div class="button" @click="addpaper">保存</div>
          <div class="button" @click="$router.go(-1)">取消</div>
        </div>
      </div>
    </div>
    <div class="contain_main content">
      <div class="right">
        <div class="title">
          <span>
            试卷名称 ：
            <i-input type="text" style="width:300px" v-model="data.eptitle" placeholder="请输入试卷名称"></i-input>
          </span>
          <span>
            多选题少选得分:
            <i-Switch size="large" v-model="epdiff">
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-Switch>
          </span>
        </div>
        <div class="title">
          <span>
            试题数量 ：
            <i-input type="text" style="width:200px" disabled v-model="data.epcount"></i-input>
          </span>
          <span>
            试题总分 ：
            <i-input type="text" style="width:200px" disabled v-model="data.epscore"></i-input>
          </span>
        </div>
        <div class="smalltitle">
          <div class="questName">
            <div
              v-for="(item,index) in list"
              @click="changetab(index)"
              :key="'title'+index"
              :class="{questNameItem:true,act:tab==index}"
            >
              <input type="text" v-model="item.title" placeholder="输入大题名称">
              <span @click.stop="delissue(index)" v-if="list.length>1">
                <Icon type="md-close"/>
              </span>
            </div>
            <div @click="addissue" class="addbigquest">+</div>
          </div>
        </div>
        <div v-for="(item,index) in list" :key="'title'+index" v-show="index==tab">
          <div class="fillNumber">
            <span>
              选择随机分类：
              <Cascader
                @on-change="classchange"
                style="width:150px;display:inline-block"
                :placeholder="item.qbtitle?item.qbtitle:'选择分类'"
                :data="questiontype"
              ></Cascader>
            </span>
          </div>
          <!-- "cate": "3",
          "easy": 1,
          "normal": 1,
          "hard": 1,
          "score": 20-->
          <div class="fillNumber">
            <span>
              当前选择共{{deError(item.class[0])+deError(item.class[1])+deError(item.class[2])}}题，随机抽题数目：
              <span style="margin-right:10px;">
                易
                <InputNumber
                  style="width:50px;"
                  @on-change="numberChange"
                  v-model="item.easy"
                  :max="item.class&&item.class[0]?item.class[0].total:0"
                  :min="0"
                ></InputNumber>
                /{{item.class&&item.class[0]?item.class[0].total:0}}
              </span>
              <span style="margin-right:10px;">
                中
                <InputNumber
                  style="width:50px"
                  @on-change="numberChange"
                  v-model="item.normal"
                  :max="item.class&&item.class[1]?item.class[1].total:0"
                  :min="0"
                ></InputNumber>
                /{{item.class&&item.class[1]?item.class[1].total:0}}
              </span>
              <span style="margin-right:10px;">
                难
                <InputNumber
                  style="width:50px"
                  @on-change="numberChange"
                  v-model="item.hard"
                  :max="item.class&&item.class[2]?item.class[2].total:0"
                  :min="0"
                ></InputNumber>
                /{{item.class&&item.class[2]?item.class[2].total:0}}
              </span>
            </span>
            <span>
              该题分值：
              <InputNumber @on-change="numberChange" v-model="item.score" :min="0"></InputNumber>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ExamPaper_add3,
  ExamPaper_getInfo1,
  ExamPaper_getBasic,
  ExamPaper_update
} from "../../assets/js/api.js";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      list: [
        {
          title: null,
          class: [{ total: 0 }, { total: 0 }, { total: 0 }],
          cate: 0,
          easy: 0,
          normal: 0,
          hard: 0,
          score: 0
        }
      ],
      data: {
        epcount: null, //	string	true	普通参数		题目数
        epscore: null, //		string	true	普通参数		总分值
        eptitle: null, //		string	true	普通参数		试卷标题
        epquestions: null //		string	true	普通参数		试卷
      },
      id: null,
      epdiff: false,
      tab: 0
    };
  },
  mounted() {
    if(this.$route.query.eptitle){
      this.data.eptitle = this.$route.query.eptitle
    }
    if (this.$route.query.editid || this.$route.query.copyid) {
      this.getdata();
    }
  },
  computed: {
    questiontype() {
      return this.$store.state.questiontype;
    },
    classmap() {
      return this.$store.state.classmap;
    }
  },
  methods: {
    // 排除异常数据
    deError(value){
      return value?value.total:0
    },
    // 添加大题
    addissue() {
      // 要做检查
      var t = this.list[this.list.length - 1];
      if (!t.title) {
        this.errorPlus("大题名称不能为空");
        return;
      }
      if (!(t.easy + t.normal + t.hard)) {
        this.errorPlus("抽取数目不能为空");
        return;
      }
      if (!t.score) {
        this.errorPlus("该大题各小题统一分数不能为空");
        return;
      }
      this.list.push({
        title: null,
        class: [{ total: 0 }, { total: 0 }, { total: 0 }],
        cate: 0,
        easy: 0,
        normal: 0,
        hard: 0,
        score: 0
      });
    },
    delissue(index) {
      if (!confirm("您确定删除该大题，删除后将不做任何保存？")) return;
      this.list.splice(index, 1);
      this.changetab(0)
    },
    changetab(index) {
      this.tab = index;
    },
    // 编辑试题部分-------
    numberChange() {
      this.data.epcount = this.list.reduce((sum, item) => {
        return (
          sum + Number(item.easy) + Number(item.normal) + Number(item.hard)
        );
      }, 0);
      this.data.epscore = this.list.reduce((sum, item) => {
        return (
          sum +
          (Number(item.easy) + Number(item.normal) + Number(item.hard)) *
            Number(item.score)
        );
      }, 0);
    },
    getdata() {
      ExamPaper_getInfo1({
        epid: this.$route.query.editid || this.$route.query.copyid
      }).then(res => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          delete this.data.epauthor;
          delete this.data.epcreatetime;
          delete this.data.epupdatetime;
          var list = res.data.data.epquestions.map((item, index) => {
            item.cate = item.cate - 0;
            item.easy = item.easy - 0;
            item.hard = item.hard - 0;
            item.normal = item.normal - 0;
            item.score = item.score - 0;
            item.qbtitle = this.classmap.get(item.cate);
            return item;
          });
          this.list = [];
          this.makelist(list).forEach(item => {
            item.then(res => {
              this.list.push(res);
            });
          });
          setTimeout(() => {
            this.numberChange();
          }, 2000);
        }
      });
    },
    // 编辑试卷时，正对获取的分类id时，对每一个该分类试题数据请求
    makelist(data) {
      if (data) {
        return data.map(async (item, index) => {
          await ExamPaper_getBasic({ id: item.cate }).then(res => {
            item.class = res.data.data;
          });
          return item;
        });
      }
    },
    //类别改变导致试题改变
    classchange(data) {
      this.list[this.tab].cate = data[data.length - 1];
      this.getclass(data[data.length - 1]);
    },
    // 获得类别
    getclass(data) {
      ExamPaper_getBasic({ id: data }).then(res => {
        if (res.data.code == 200) {
          this.list[this.tab].class = res.data.data.sort(
            (a, b) => a.questionlevel - b.questionlevel
          );
          this.$set(this.list, this.tab, this.list[this.tab]);
        }
      });
    },
    // 添加试题部分
    addpaper() {
      var t = this.list[this.list.length - 1];
      if (!t.title) {
        this.errorPlus("最后一道大题名称不能为空");
        return;
      }
      if (!(t.easy + t.normal + t.hard)) {
        this.errorPlus("最后一道大题抽取数目不能为空");
        return;
      }
      if (!t.score) {
        this.errorPlus("最后一道大题各小题统一分数不能为空");
        return;
      }
      if (!this.data.eptitle) {
        this.errorPlus("试卷名称不能为空");
        return;
      }
      if (this.data.eptitle && this.data.eptitle.length > 100) {
        this.errorPlus("试卷标题不能超过100字");
        return;
      }
      // if(this.checkSimilar){
      //   this.errorPlus("有重复题目，请点击“试题去重”按钮后提交");
      //   return;
      // }
      // epcount	string	true	普通参数		题目数
      // epscore	string	true	普通参数		总分值
      // eptitle	string	true	普通参数		试卷标题
      // epquestions	string	true	普通参数		试卷
      this.numberChange();
      this.data.epquestions = this.list.map(item => {
        delete item.class;
        return item;
      });
      this.data.epdiff = this.epdiff - 0;
      if (this.$route.query.editid) {
        this.data.epid = this.$route.query.editid;
        ExamPaper_update(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "编辑保存成功！" });
            this.$router.push("/manage/publiclist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      } else {
        ExamPaper_add3(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "保存成功！" });
            this.$router.push("/manage/publiclist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    scan() {
      if (this.data.eptitle) {
        this.$router.push({
          path: "/manage/radompaper",
          query: {
            eptitle: this.data.eptitle
          }
        });
      }
      if (!this.list.length) {
        this.errorPlus("请编辑或导入试题");
        return;
      }
      this.data.epquestions = this.list;
      this.$router.push({ name: "scanpaper", params: { message: this.data } });
    }
  }
};
</script>
<style lang="css" scoped>
.normalpaper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.header {
  height: 0.8rem;
  text-align: left;
  border-bottom: #e8e9ee 1px solid;
}
.header .contain_main {
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.logo {
  width: 1.84rem;
  height: 0.4rem;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.15rem;
}
.content {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 0.8rem);
}
.right {
  width: 100%;
  height: 100%;
}
.smalltitle {
  padding: 20px;
  margin-top: 40px;
}
.questName {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.questNameItem {
  border-bottom: 2px solid #474dff;
  padding: 10px;
  background: #eff2f7;
  margin-right: 10px;
}
.questNameItem input {
  background: transparent;
  width: 100px;
}
.questNameItem.act {
  border-bottom: 2px solid #474dff;
  padding: 10px;
  background: #ccddff;
  color: #474dff;
  margin-right: 10px;
}
.questNameItem.act input {
  background: transparent;
  width: 100px;
  color: #474dff;
}

.questNameItem.act input::placeholder {
  color: #474dff;
}
.questNameItem .close {
  color: #bbb;
  margin-left: 10px;
}
.fillNumber {
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  margin: 0 20px 20px;
  align-items: center;
}
.addbigquest {
  width: 40px;
  background: #ffd6de;
  color: #ff064e;
  text-align: center;
  line-height: 45px;
  font-size: 28px;
  /* font-weight: bold; */
}
.title {
  text-align: left;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/radompaper.vue